
import axios from '../Api/axios';
import useAuthSetState from './useAuthSetState';
// import { ROLES } from '../config';
// import useAuth from './useAuth';

// ! search the interval of time when it will be excecuted ,, wheen [evry route change , every 30s .. ???]
const useRefreshToken = () => {
    const {setAuthState} = useAuthSetState();
    // const { pathname } = useLocation();
    // const { setAuth } = useAuth();

    const refresh = async () => {
        let response;
        try {
            // axios.defaults.withCredentials = true;
            response = await axios.get('/refresh', {
                // setting that allows us to send cookies with our request
                // especially http only cookies that we could not see using Javascript
                withCredentials: true //! without it, it wont't send and save refreshToekn cookie jwt
            });
            setAuthState({responseData: response.data});
        } catch (error) {
            console.log('session expired, you need to re-login', error);
            return null;
            // * it's better to do  it on axiosPrivate hook
            //  if(isAuthentificatedRoute(pathname))
            //     window.location.reload();

            // ! I was doint after a request
            // //! trying to refresh ,, in order to change the AuthCOntext info ,, but it didn't work, setAuth maybe will works .. or in worst cases .. use REDUX
            // refresh();
        }
        // // ! maybe many Roles
        // const role = response?.data?.user.role;
        // // const hashedPassword = response?.data?.user.password;
        // let UserRoleProperty ;
        // if(role === ROLES.Expert) UserRoleProperty = 'expertId';
        // if(role === ROLES.Client) UserRoleProperty = 'collaboratorId';
        // if(role === ROLES.Admin) UserRoleProperty = 'backOfficeId';

        // setAuth(prev => {
        //     // console.log(JSON.stringify(prev));
        //     console.log(prev);
        //     console.log(response.data.accessToken);
        //     // override access token with new access token, other values like role will still the same
        //     return {
        //         ...prev,
        //         roles: response.data.role,
        //         accessToken: response.data.accessToken,
        //         // ! after the probleme of completeProfile Refresh, I lost all data in contextAPI
        //         email: response.data.email,
        //         completeStep: response.data.completeStep,
        //         // ?
        //         photo: response?.data.user?.[UserRoleProperty]?.persoData?.photo,
        //         nom: response?.data.user?.[UserRoleProperty]?.persoData?.nom??'',
        //         prenom: response?.data.user?.[UserRoleProperty]?.persoData?.prenom??'',
        //     };
        // });
        return response.data.accessToken;
    };
    return refresh;
};

export default useRefreshToken;
